import { Component } from '@angular/core';

@Component({
  selector: 'app-unauthorized',
  standalone: true,
  template: `
    <div class="animated fadeIn">
      <div class="row">
        <div class="col-lg-12">
          <div class="clearfix">
            <h1 class="float-left display-3 mr-4">401</h1>
            <h4 class="pt-3">UNAUTHORIZED</h4>
            <p class="text-muted">許可されていない操作です。</p>
          </div>
        </div>
      </div>
    </div>
  `,
})
export class UnauthorizedComponent {}
